module.exports = __webpack_public_path__ + "img/clock.9678ed91.svg";